import { omit } from "lodash";
import React, { PureComponent, Fragment } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";

import SSHTable from "../../sshKeys/SSHTable.jsx";

import { PANEL_STATES } from "../../../state/reducers/projectWizard/projectWizardConstants.js";

import { selectCopy } from "../../../state/reducers/locale/copySelector.js";

class SSHPanel extends PureComponent {
  static propTypes = {
    id: PropTypes.string.isRequired,
    limits: PropTypes.object,
    formikProps: PropTypes.object.isRequired, // required for ResourceBlock selectors to function
    apiErrors: PropTypes.object,
    disabled: PropTypes.bool.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "project_wizard.ssh_panel"
  };

  // -- RENDER -- //

  renderPanelBody(bodyCopy) {
    const { copyKey, copy } = this.props;

    return (
      <Fragment>
        <Header as="h3" attached="top" block>
          {copy(`${copyKey}.title`)}
        </Header>

        <Segment clearing={true} attached>
          <p>{bodyCopy}</p>
          <SSHTable {...omit(this.props, "copyKey")} />
        </Segment>
      </Fragment>
    );
  }

  renderActive() {
    const { copyKey, copy } = this.props;
    return this.renderPanelBody(copy(`${copyKey}.body`));
  }

  renderOptional() {
    const { copyKey, copy } = this.props;
    return this.renderPanelBody(copy(`${copyKey}.body_optional`));
  }

  renderInactive() {
    return null;
  }

  render() {
    const { view } = this.props;

    switch (view) {
      case PANEL_STATES.ACTIVE:
        return this.renderActive();
      case PANEL_STATES.OPTIONAL:
        return this.renderOptional();
      default:
        return this.renderInactive();
    }
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(SSHPanel);
